import Downshift from 'downshift';
import List, {
  DropdownListWrapper,
} from 'components/styled/DropdownList/DropdownList';
import { logToAmplitude } from 'helpers/logAmplitudeEvent';
import { ReactComponent as DownloadIcon } from 'icons/icon-download.svg';
import { IconWrapper, SquareButton } from './ToolbarOptions.style';
import stringToSlug from 'helpers/stringToSlug';

const clickOnReference = (title) => {
  logToAmplitude('Export Button Clicked', {
    section: title,
  });
};

const DropdownOption = ({ item, option, title, singleDataDownload }) => {
  const cyKey = `toolbar-dropdown-item-${stringToSlug(item.label)}-${option}-${
    item.order
  }`;
  let label = `${item.label} - ${option}`;
  if (singleDataDownload) {
    label = `${option}`;
  }

  return (
    <li key={cyKey} data-pw={cyKey}>
      <a
        data-testid={cyKey}
        href={item.href}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => clickOnReference(title)}
        {...item.otherProps}
      >
        <span>{label}</span>
      </a>
    </li>
  );
};

export const ExportButton = ({ data, title }) => {
  const sortByOrder = (item1, item2) => (item1.order > item2.order ? 1 : -1);
  const sortedData = data.items.sort(sortByOrder);
  const singleDataDownload = sortedData.length === 1;

  return (
    <Downshift id="ExportDropdown">
      {({ isOpen, toggleMenu }) => {
        return (
          <div>
            <SquareButton
              aria-haspopup="true"
              aria-expanded={isOpen}
              onClick={toggleMenu}
              isOpen={isOpen}
              data-pw="context-menu"
              data-testid="context-menu-button"
            >
              <IconWrapper>
                <DownloadIcon data-pw="export" />
              </IconWrapper>
            </SquareButton>
            {isOpen && (
              <DropdownListWrapper
                overflowLeft
                data-pw="context-menu-list"
                data-testid="context-menu-list"
              >
                <List>
                  {sortedData.map((item) => {
                    return (
                      <>
                        <DropdownOption
                          key={item.order}
                          item={item}
                          option={'CSV'}
                          title={title}
                          singleDataDownload={singleDataDownload}
                        />
                        {/* PDF functionality not enabled yet - OPUS-2206, Figma File comments 
                        <DropdownOption
                          item={item}
                          option={'PDF'}
                          title={title}
                          singleDataDownload={singleDataDownload}
                        />*/}
                      </>
                    );
                  })}
                </List>
              </DropdownListWrapper>
            )}
          </div>
        );
      }}
    </Downshift>
  );
};
